/** Имя префикса: латиница/цифры, с буквы, 1…20 (паритет с API). */
export const PREFIX_NAME_MAX_LENGTH = 20;
export const PREFIX_NAME_PATTERN = /^[A-Za-z][A-Za-z0-9]{0,19}$/;
export const PREFIX_NAME_HINT = 'Уникальное имя: латиница и цифры; с буквы; до 20 символов (например VRN, GPN, RITEK).';
/** host:port с опциональным /path (без пробелов). */
const HOST_PORT_PATTERN = /^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*|localhost|(?:\d{1,3}\.){3}\d{1,3}):(\d{1,5})(?:\/\S*)?$/i;
export const DESTINATION_URL_HINT = 'Куда слать: http(s)://…, host:port[/path] или /path. Без пробелов. Для WIALON — host:port (часто 20332).';
/**
 * @returns {string|null} текст ошибки или null, если ок
 */
export function validatePrefixName(value) {
    const name = typeof value === 'string' ? value.trim() : '';
    if (!name) {
        return 'Укажите префикс';
    }
    if (name.length > PREFIX_NAME_MAX_LENGTH) {
        return `Префикс не длиннее ${PREFIX_NAME_MAX_LENGTH} символов`;
    }
    if (!PREFIX_NAME_PATTERN.test(name)) {
        return 'Префикс: только латиница и цифры; должен начинаться с буквы';
    }
    return null;
}
/**
 * Адрес доставки: trim, без пробелов, http(s) / host:port /path.
 * @returns {string|null}
 */
export function validateDestinationUrl(value) {
    const url = typeof value === 'string' ? value.trim() : '';
    if (!url) {
        return 'Укажите адрес (куда)';
    }
    if (url.length > 500) {
        return 'Адрес не длиннее 500 символов';
    }
    if (/\s/.test(url)) {
        return 'Адрес не должен содержать пробелы';
    }
    if (/^https?:\/\//i.test(url)) {
        try {
            const parsed = new URL(url);
            if (!parsed.hostname) {
                return 'Некорректный URL: укажите хост';
            }
            return null;
        }
        catch (_a) {
            return 'Некорректный URL (http/https)';
        }
    }
    if (url.startsWith('/')) {
        if (url.length < 2) {
            return 'Укажите путь, например /webhook';
        }
        return null;
    }
    const hostPort = url.match(HOST_PORT_PATTERN);
    if (hostPort) {
        const port = Number(hostPort[1]);
        if (port < 1 || port > 65535) {
            return 'Порт должен быть от 1 до 65535';
        }
        return null;
    }
    return 'Укажите URL (http/https), host:port или путь вида /path';
}
/** Сообщение из ответа Nest (http interceptor отдаёт error.response). */
export function getApiErrorMessage(error, fallback = 'Ошибка запроса') {
    var _a;
    const message = (_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message;
    if (Array.isArray(message) && message.length) {
        return message.join('; ');
    }
    if (typeof message === 'string' && message.trim()) {
        return message;
    }
    return fallback;
}
